var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "ChatbotAiPrompt" } }, [
    _c(
      "div",
      [
        _c("h1", [_vm._v("Chatbot Ai Prompt")]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n            Artificial intelligence learns and determines how it should behave by being given instructions about a\n            specific task or problem using the 'prompt' feature.\n        "
          ),
        ]),
        _vm._v(" "),
        _c("a-textarea", {
          staticStyle: { height: "500px" },
          attrs: {
            placeholder: "Enter the prompt",
            "auto-size": { minRows: 2, maxRows: 5 },
            disabled: _vm.isDisabled,
          },
          model: {
            value: _vm.promptText,
            callback: function ($$v) {
              _vm.promptText = $$v
            },
            expression: "promptText",
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "settings-btn" },
          [
            _c(
              "SupsisButton",
              { attrs: { ghost: "" }, on: { click: _vm.clearPrompt } },
              [_vm._v("\n                Cancel\n            ")]
            ),
            _vm._v(" "),
            _c(
              "SupsisButton",
              {
                attrs: { primary: "", disabled: _vm.isDisabled },
                on: { click: _vm.updatePrompt },
              },
              [_vm._v("Save\n            ")]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("hr"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }